import React, { useState, useEffect } from 'react';
import useStore from '../store/useStore';

function WallConfiguration({ maxLEDWidth, maxLEDHeight, setMaxLEDWidth, setMaxLEDHeight, panelDetails, error, setError}) { 

  const unit = useStore((state) => state.unit);
  const wallWidth = useStore((state) => state.wallWidth);
  const setWallWidth = useStore((state) => state.setWallWidth);
  const wallHeight = useStore((state) => state.wallHeight);
  const setWallHeight = useStore((state) => state.setWallHeight);
  
  const [tempWallWidth, setTempWallWidth] = useState(wallWidth.toString());
  const [tempWallHeight, setTempWallHeight] = useState(wallHeight.toString());

  // Update tempWallWidth when wallWidth changes
  useEffect(() => {
    setTempWallWidth(parseFloat(wallWidth).toFixed(2));
  }, [wallWidth]); 
  
  // Update tempWallHeight when wallHeight changes
  useEffect(() => {
    setTempWallHeight(parseFloat(wallHeight).toFixed(2));
    //setTempWallHeight(parseFloat(tempWallHeight).toFixed(2));
  }, [wallHeight]);

  const updateWallWidth = (newWidth) => {
    const afterWidth = (maxLEDWidth - panelDetails.panelWidth).toFixed(2);
    if(newWidth <= 100){
      setWallWidth(parseFloat(newWidth).toFixed(2));
      setTempWallWidth(parseFloat(newWidth).toFixed(2));
      if (newWidth >= maxLEDWidth) {
           setError('');
      }else{
           if(newWidth > panelDetails.panelWidth){
            setMaxLEDWidth(parseFloat(afterWidth));
            setError("");
           }else{
            setWallWidth(panelDetails.panelWidth);
            setMaxLEDWidth(panelDetails.panelWidth);
            setTempWallWidth(panelDetails.panelWidth);
            //setError("5");
           }
      }
    }else if(newWidth > 100){
      setError("Maximum width allowed is 100.")
    }
  };

  const updateWallHeight = (newHeight) => {
    const afterHeight = (maxLEDHeight - panelDetails.panelHeight).toFixed(2);
    if(newHeight <= 100){
      setWallHeight(parseFloat(newHeight).toFixed(2));
      setTempWallHeight(parseFloat(newHeight).toFixed(2));
        if (newHeight >= maxLEDHeight) {
            //setError('1');
        }else{
            if(newHeight > panelDetails.panelHeight){
              setMaxLEDHeight(parseFloat(afterHeight));
              //setTempWallHeight(parseFloat(afterHeight));
              setError('');
            }else{
              setWallHeight(panelDetails.panelHeight);
              setMaxLEDHeight(panelDetails.panelHeight);
              setTempWallHeight(panelDetails.panelHeight);
              //setError('3');
            }
        }
    }else if(newHeight > 100){
      setError("Maximum height allowed is 100.")
    }
  };

  const validateAndSetWidth = (value) => {
    // Here you can include the validation logic and update the actual wallWidth if valid
    let numericValue = parseFloat(value);
    if (!isNaN(numericValue) && numericValue <= 100 && numericValue >= 1) {
      if(numericValue <= maxLEDWidth){
        setWallWidth(maxLEDWidth);
        //setError('Wall Width Not Allowed Shorter Than Display Columns Width.');
      }else{
        setWallWidth(numericValue);
        setError('');
      }
    } else if (!isNaN(numericValue) && numericValue > 100) {
      setError('Maximum Width Allowed is 100.');
    } else if (!isNaN(numericValue) && numericValue < 1) {
      setError('Minimum Width Allowed is 1.');
    } else {
      setError('Invalid Width.');
    }
  };

  const validateAndSetHeight = (value) => {
    // Similar validation logic for height
    let numericValue = parseFloat(value);
    if (!isNaN(numericValue) && numericValue <= 100 && numericValue >= 1) {
      if(numericValue <= maxLEDHeight){
        setWallHeight(maxLEDHeight);
        //setError('Wall Height Not Allowed Shorter Than Display Rows Height.');
      }else{
        setWallHeight(numericValue);
        setError('');
      }
    } else if (!isNaN(numericValue) && numericValue > 100) {
      setError('Maximum Height Allowed is 100.');
    } else if (!isNaN(numericValue) && numericValue < 1) {
      setError('Minimum Height Allowed is 1.');
    } else {
      setError('Invalid Height.');
    }
  };

  const handleWidthChange = (e) => {
    // Update temporary state
    let value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/, '$1');
    setTempWallWidth(value);
  };

  const handleHeightChange = (e) => {
    // Update temporary state
    let value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/, '$1');
    setTempWallHeight(value);
  };

    return (

      <div className="custom-border-color p-4 mt-3">
              <h4>Wall Max Size</h4><hr/>
                  <div className="row mb-3">
                     <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-3">
                        <div className="fw-bold mt-2" id="text-primary">Wall Width</div>
                     </div>
                     <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-6 mt-1">
                        <button className="btn" id="btn-primary" onClick={() => wallWidth > 1 && updateWallWidth(wallWidth - 1)}>-</button>
                        <input 
                            className="text-center mx-2"
                            id="button-plus-width"
                            type="text"
                            value={tempWallWidth}
                            onChange={handleWidthChange}
                            onBlur={() => validateAndSetWidth(tempWallWidth)} // Validate on blur
                            style={{ width: '100px' }} 
                        />
                        <button className="btn" id="btn-primary" onClick={() => updateWallWidth(parseFloat(wallWidth) + 1)}>+</button>
                     </div>
                     <div className="col-12 col-sm-3 mt-2">{ unit === 'ft' ? (1 * wallWidth).toFixed(2) : (0.3048 * wallWidth).toFixed(2)} ({unit})</div>
                </div>
                <div className="row mb-3">
                    <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-3">
                        <div className="fw-bold mt-2" id="text-primary">Wall Height</div>
                    </div>
                    <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-6">
                        <button className="btn" id="btn-primary" onClick={() => wallHeight > 1 && updateWallHeight(wallHeight - 1)}>-</button>
                        <input 
                            className="text-center mx-2"
                            id="button-plus-height"
                            type="text"
                            value={tempWallHeight}
                            onChange={handleHeightChange}
                            onBlur={() => validateAndSetHeight(tempWallHeight)} // Validate on blur
                            style={{ width: '100px' }} 
                        />
                        <button className="btn" id="btn-primary" onClick={() => updateWallHeight(parseFloat(wallHeight) + 1)}>+</button>
                    </div>
                    <div className="col-12 col-sm-3 mt-1">{unit ==='ft' ? (1 * wallHeight).toFixed(2) : (0.3048 * wallHeight).toFixed(2)} ({unit})</div>
                </div>
                  {error && <div style={{ color: 'red', fontWeight : 'bold', textAlign: 'center' }}>{error}</div>}
            </div>

    );
}

export default WallConfiguration;
